import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import SectionLabel from '../components/SectionLabel';
import BookingCTA from '../components/BookingCTA';
import SEO from '../components/SEO';
import { useLang } from '../context/LanguageContext';

const Diensten = () => {
  const { c, ui, lp } = useLang();
  const t = ui.diensten;
  return (
    <div className="bg-[#0a0a0b] text-white pt-32 pb-24">
      <SEO
        path="/diensten"
        title="Diensten — Detailing, Coating, PPF & Lakcorrectie"
        description="Onze diensten: detailing, keramische coating, PPF (Paint Protection Film), lakcorrectie, ramentinten en auto wrappen. Premium autodetailing in Deventer."
        keywords="autodetailing diensten, keramische coating, PPF, lakcorrectie, ramentinten, auto wrappen, Deventer"
      />
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <SectionLabel>{t.label}</SectionLabel>
        <h1 className="mt-5 text-5xl md:text-7xl font-medium tracking-tight leading-[1.02] max-w-4xl">
          {t.title}
        </h1>
        <p className="mt-6 text-white/60 max-w-2xl text-lg">
          {t.subtitle}
        </p>

        <div className="mt-20 space-y-24 lg:space-y-32">
          {c.services.map((s, i) => {
            const reverse = i % 2 === 1;
            return (
              <article
                key={s.slug}
                className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center"
              >
                <div className={`relative rounded-2xl overflow-hidden aspect-[4/3] ${reverse ? 'lg:order-2' : ''}`}>
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                  <span className="absolute top-5 left-5 text-white/70 text-xs tracking-[0.3em]">
                    {s.number}
                  </span>
                </div>

                <div className={reverse ? 'lg:order-1' : ''}>
                  <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.1]">
                    {s.title}
                  </h2>
                  <p className="mt-5 text-white/70 text-lg leading-relaxed">
                    {s.description}
                  </p>

                  <div className="mt-8">
                    <div className="text-white/50 text-xs tracking-[0.25em] uppercase mb-3">
                      {t.suitableFor}
                    </div>
                    <ul className="space-y-2.5">
                      {s.suitableFor.map(item => (
                        <li key={item} className="flex items-start gap-3 text-white/85">
                          <span className="mt-1 w-5 h-5 rounded-full bg-[#2f6bff]/20 text-[#2f6bff] flex items-center justify-center flex-shrink-0">
                            <Check className="w-3 h-3" />
                          </span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mt-10 flex flex-wrap items-center gap-6">
                    <div>
                      <div className="text-white/40 text-[11px] tracking-wider uppercase">{t.price}</div>
                      <div className="mt-1 text-2xl md:text-3xl font-medium text-white">{s.price}</div>
                    </div>
                    <BookingCTA
                      waMessage={t.waQuote(s.title)}
                      offerteTreatment={s.title}
                    />
                    <Link
                      to={lp('service', { slug: s.slug })}
                      className="text-white/70 hover:text-white text-sm inline-flex items-center gap-1.5 transition-colors"
                    >
                      {t.moreInfo}
                      <ArrowRight className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-32 p-10 md:p-16 rounded-2xl border border-white/10 bg-gradient-to-br from-white/[0.04] to-transparent text-center">
          <h2 className="text-4xl md:text-5xl font-medium tracking-tight leading-[1.05]">
            {t.ctaTitle}
          </h2>
          <p className="mt-4 text-white/60 max-w-xl mx-auto">
            {t.ctaText}
          </p>
          <div className="mt-8 flex justify-center">
            <BookingCTA size="lg" align="center" waMessage={t.waAdvice} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Diensten;
